import {DEFAULT_PATH} from "./components/auth/accessTokenValidator.js";
import {Manufacturers} from "./components/pages/Manufacturers.jsx";
import {Users} from "./components/pages/Users.jsx";
import Permissions from "./components/pages/Permissions.jsx";
import {Home} from "./components/pages/Home.jsx";
import GeoFamily from "./components/pages/metadata/GeoFamily.jsx";
import {CompanyContracts} from "./components/pages/company/CompanyContracts.jsx";
import {Company} from "./components/pages/company/Company.jsx";
import {Approvals} from "./components/pages/Approvals.jsx";
import {Powertabs} from "./components/pages/powertabs/Powertabs.jsx";
import {CreateSubscription as CreatePowertabsSubscription} from "./components/pages/powertabs/CreateSubscription.jsx";
import {Explorer} from "./components/pages/explorer/Explorer.js";
import {
    EditSubscription as PowertabsEditSubscription
} from "./components/pages/powertabs/editSubscription/EditSubscription.jsx";
import {CreateSubscription as CreateScorecardsSubscription} from "./components/pages/scorecards/CreateSubscription.jsx";
import {Subscriptions} from "./components/pages/scorecards/Subscriptions.jsx";
import {CreateContract} from "./components/pages/scorecards/CreateContract.jsx";
import {PowertabsInstances} from "./components/pages/powertabs/PowertabsInstances.jsx";
import {PowertabsStatus} from "./components/pages/powertabs/PowertabsStatus.jsx";
import {UpdateMarkets} from "./components/pages/scorecards/UpdateMarkets.jsx";
import {Markets} from "./components/pages/scorecards/Markets.jsx";
import {AvailableScorecards} from "./components/pages/noshe/AvailableScorecards.jsx";
import {LegacyScorecards} from "./components/pages/period-release/LegacyScorecards.jsx";
import {RetailIntelligence} from "./components/pages/period-release/RetailIntelligence.jsx";
import {EditSubscription} from "./components/pages/cns/subscription/EditSubscription.jsx";
import {CreateSubscription} from "./components/pages/cns/subscription/CreateSubscription.jsx";
import {IframeTester} from "./components/pages/noshe/IframeTester.jsx";
import {AccessAdmin} from "./components/pages/noshe/AccessAdmin/AccessAdmin.jsx";
import {SubscriptionList} from "./components/pages/cns/subscriptionList.jsx";
import {AdminOptions} from "./components/pages/cns/AdminOptions.jsx";
import {VMInstances} from "./components/pages/cns/VMInstances.jsx";
import {MidMarket} from "./components/pages/mid-market/MidMarket.jsx";
import {DataSubscription} from "./components/pages/data-subscription/DataSubscription.jsx";
import {SubscriptionsList} from "./components/pages/data-subscription/subscriptions-list/SubscriptionsList.jsx";
import {KeyAccountsApproval} from "./components/pages/key-accounts/KeyAccountsApproval.jsx";
import {EditDataSubscription} from "./components/pages/data-subscription/edit-subscription/EditDataSubscription.jsx";
import {DaapSubscription} from "./components/pages/daap/DaapSubscription.jsx";
import {SpinsIntelligence} from "./components/pages/spins-intelligence/SpinsIntelligence.jsx";


export const ROUTES = [
    {
        path: DEFAULT_PATH,
        Component: Home,
    },
    {
        path: "/approvals",
        Component: Approvals,
    },
    {
        path: "/company",
        Component: Company,
    },
    {
        path: "/companyContracts",
        Component: CompanyContracts,
    },
    {
        path: "/explorer",
        Component: Explorer,
    },
    {
        path: "/geoFamily",
        Component: GeoFamily,
    },
    {
        path: "/manufacturers",
        Component: Manufacturers,
    },
    {
        path: "/permissions",
        Component: Permissions,
    },
    {
        path: "/powertabs",
        Component: Powertabs,
    },
    {
        path: "/powertabs/create-subscription",
        Component: CreatePowertabsSubscription,
    },
    {
        path: "/powertabs/subscriptions/:id",
        Component: PowertabsEditSubscription,
    },
    {
        path: "/powertabs/instances",
        Component: PowertabsInstances,
    },
    {
        path: "/powertabs/status",
        Component: PowertabsStatus,
    },
    {
        path: "/cs/subscriptions",
        Component: SubscriptionList,
    },
    {
        path: "/cs/admin",
        Component: AdminOptions,
    },
    {
        path: "/cs/vm-instances",
        Component: VMInstances,
    },
    {
        path: "/cs/create-subscription",
        Component: CreateSubscription,
    },
    {
        path: "/cs/edit-subscription/:id",
        Component: EditSubscription,
    },
    {
        path: "/scorecards/create-subscription",
        Component: CreateScorecardsSubscription,
    },
    {
        path: "/scorecards/create-contract",
        Component: CreateContract,
    },
    {
        path: "/scorecards/markets",
        Component: Markets,
    },
    {
        path: "/scorecards/subscriptions",
        Component: Subscriptions,
    },
    {
        path: "/scorecards/update-markets",
        Component: UpdateMarkets,
    },
    {
        path: "/noshe/access-admin",
        Component: AccessAdmin,
    },
    {
        path: "/noshe/available-scorecards",
        Component: AvailableScorecards,
    },
    {
        path: "/noshe/iframe-tester",
        Component: IframeTester,
    },
    {
        path: "/users",
        Component: Users,
    },
    {
        path: "/period-release/retail-intelligence",
        Component: RetailIntelligence,
    },
    {
        path: "/period-release/legacy-scorecards",
        Component: LegacyScorecards,
    },
    {
        path: "/mid-market-report",
        Component: MidMarket,
    },
    {
        path: "/data-subscription/create",
        Component: DataSubscription,
    },
    {
        path: "/data-subscription/edit/:salesforceid",
        Component: EditDataSubscription,
    },
    {
        path: "/data-subscription/subscriptions-list",
        Component: SubscriptionsList
    },
    {
        path: "/key-accounts-approval",
        Component: KeyAccountsApproval
    },
    {
        path: "/daap",
        Component: DaapSubscription
    },
    {
        path: "/spins-intelligence",
        Component: SpinsIntelligence
    }
];
